import { GeoAddressRequest, ProductsAdditionalInfo } from "../..";

export interface AddMasterPlanLocationRequest {
    planContainerId: string;
    locationGroupId?: string;
    locationId: string;
    locationName: string;
    address: string;
    geoAddress: GeoAddressRequest
    postalCode: string;
    city: string;
    country: string;
    locationType : number;
    productAdditionalInfo?: string;
    segment?: string;
    stopTime?: string;
    isInfrastructure?: boolean | undefined;
}